/**
 * Auth-related API shapes shared by worker + web (T-010).
 */
import { z } from "zod";

export const StaffInviteCreated = z.object({
  id: z.uuid(),
  /** Shown once to the inviting admin — Wave 2 sends it by email */
  accept_url: z.string(),
});
export type StaffInviteCreated = z.infer<typeof StaffInviteCreated>;

// [M4-03] native app BFF (doc18 §4 · D-041 M4-1)

export const NativeAuthStart = z.object({
  device_name: z.string().trim().min(1).max(80),
  platform: z.enum(["ios", "android", "web"]),
});
export type NativeAuthStart = z.infer<typeof NativeAuthStart>;

export const NativeAuthStartResponse = z.object({
  flow_id: z.uuid(),
  authorize_url: z.string(),
  expires_at: z.string(),
});
export type NativeAuthStartResponse = z.infer<typeof NativeAuthStartResponse>;

export const NativeAuthExchange = z.object({
  flow_id: z.uuid(),
  handoff_code: z.string().min(1).max(128),
});
export type NativeAuthExchange = z.infer<typeof NativeAuthExchange>;

export const NativeAuthExchangeResponse = z.object({
  token: z.string(),
  expires_at: z.string(),
});
export type NativeAuthExchangeResponse = z.infer<typeof NativeAuthExchangeResponse>;
